import {createSvgIcon} from "@mui/material";
import {useId} from "react";

const DownloadIcon = createSvgIcon(
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <IconContent />
  </svg>,
  'Download'
)

function IconContent() {
    const clipId = useId();
    return (
        <>
            <g clipPath={`url(#${clipId})`}>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M12 2.47576C6.57757 2.47576 2.18182 6.87151 2.18182 12.2939C2.18182 17.7164 6.57757 22.1121 12 22.1121C17.4224 22.1121 21.8182 17.7164 21.8182 12.2939C21.8182 6.87151 17.4224 2.47576 12 2.47576ZM0 12.2939C0 5.66653 5.37258 0.293945 12 0.293945C18.6274 0.293945 24 5.66653 24 12.2939C24 18.9214 18.6274 24.2939 12 24.2939C5.37258 24.2939 0 18.9214 0 12.2939Z"
                      fill="#E10B17"/>
                <path fillRule="evenodd" clipRule="evenodd"
                      d="M12.0007 7.29395C12.4609 7.29395 12.834 7.74166 12.834 8.29395L12.834 16.2939C12.834 16.8462 12.4609 17.2939 12.0007 17.2939C11.5404 17.2939 11.1673 16.8462 11.1673 16.2939L11.1673 8.29395C11.1673 7.74166 11.5404 7.29395 12.0007 7.29395Z"
                      fill="#E10B17"/>
                <path d="M16.1673 12.2938L12.0007 16.4604L7.83398 12.2938" stroke="#E10B17" strokeWidth="1.66667"
                      strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
            <clipPath id={clipId}>
                    <rect width="24" height="24" fill="white" transform="translate(0 0.293945)"/>
                </clipPath>
            </defs>
        </>
    )
}

export default DownloadIcon;
